import {
  AnimatedButtonContainer,
  AnimatedButtonRow,
  Button,
} from "@babackapp/customer-ui/components/button";
import {
  Header,
  HeaderDescription,
  HeaderTitle,
  SectionHeader,
} from "@babackapp/customer-ui/components/header";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import { formatPrice } from "@babackapp/return-widget-components/utils/format-price";
import { EnterIcon } from "@radix-ui/react-icons";
import { ShoppingBagIcon } from "lucide-react";
import { Suspense } from "react";
import { useShopNowResolve } from "../hooks/use-shop-now-resolve";

function ShopNowResolveInner() {
  const { items, currency, cartTotal, handleAddMore, handleConfirm } = useShopNowResolve();

  return (
    <WidgetPage>
      <Header>
        <HeaderTitle>Articles sélectionnés</HeaderTitle>
        <HeaderDescription>
          Confirmez les articles ajoutés à votre panier pour finaliser votre retour.
        </HeaderDescription>
      </Header>

      {items.length > 0 ? (
        <div className="w-full mt-4 flex flex-col gap-4">
          <SectionHeader>Nouveaux articles</SectionHeader>
          <ul className="flex flex-col gap-2">
            {items.map((item, i) => (
              <li key={`${item.variantId}-${i}`} className="flex justify-between text-sm">
                <span>{item.title} ×{item.quantity}</span>
                <span>{formatPrice(item.price * item.quantity, currency)}</span>
              </li>
            ))}
          </ul>
          <div className="flex justify-between text-sm font-medium">
            <span>Total panier</span>
            <span>{formatPrice(cartTotal, currency)}</span>
          </div>
        </div>
      ) : (
        <p className="text-sm text-muted-foreground mt-4">Chargement des articles…</p>
      )}

      <AnimatedButtonRow variants={{}}>
        <AnimatedButtonContainer layoutId="shop-now-add-more" variants={{}}>
          <Button variant="secondary" onClick={handleAddMore}>
            <ShoppingBagIcon />
            Ajouter des articles
          </Button>
        </AnimatedButtonContainer>
        <AnimatedButtonContainer layoutId="shop-now-resolve-confirm" variants={{}}>
          <Button disabled={items.length === 0} onClick={handleConfirm}>
            <EnterIcon />
            Confirmer le retour
          </Button>
        </AnimatedButtonContainer>
      </AnimatedButtonRow>
    </WidgetPage>
  );
}

export function ShopNowResolvePage() {
  return (
    <Suspense fallback={null}>
      <ShopNowResolveInner />
    </Suspense>
  );
}
